// https://material.angular.io/components/table/overview
import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { ReciboPagoEliminarComponent } from './recibo-pago-eliminar.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DomSanitizer } from '@angular/platform-browser';
import { PersonalPDF, Personal } from '../../models/personal';
import * as moment from 'moment';
import { FormControl, Validators } from '@angular/forms';
import { ReciboPagoDetalleComponent } from '../agregar-editar/recibo-pago-detalle.component';
import { ReciboPago, ReciboPagoDetalle, ReciboPagoDocumento } from '../../models/ReciboPago';
import { Cliente } from '../../models/cliente';
import { SelectionModel } from '@angular/cdk/collections';
import { ExcelServiceHeader } from '../../utils/excel.service';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/FacturaFormaPago';
import { FacturaMetodoPago } from '../../models/FacturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/FacturaUsoCFDI';
import { FacturaItem } from '../../models/facturaItem';
import { FacturaItemSAT } from '../../models/facturaItemSAT';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Organizacion } from '../../models/organizacion';
import { Usuario } from '../../models/usuario';
import { ReciboPagoDescargarComponent } from './recibo-pago-descargar.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common'
import { param } from 'jquery';
/**
 * @title Table with pagination
 */
 @Component({
   selector: 'my-recibo-pago-consultar',
   styleUrls: ['recibo-pago-consultar.component.scss'],
   templateUrl: 'recibo-pago-consultar.component.html',
   providers: [generalService, ExcelServiceHeader]
 })
 export class ReciboPagoConsultarComponent {

   public viewDataCliente: any[];
   private itemsShow = 10;
   private filteredItemsShowCliente = 10;
  private arrayFilteredCliente = undefined;
  private isFilteredCliente = false;
  @ViewChild('infiniteSelect') selectElem: MatSelect;

   public datosGeneralesSAE: any;
   dataSource: DataSourceGrid | null;
   displayedColumns = ['acciones', 'CUSTOMER_NAME', 'DESCRIPTION_STATUS', 'RECEIPT_PAYMENT_NUMBER', 'TOTAL', 'PAYMENT_DATE', 'DOCUMENTOS'];

   public listaReciboPago: ReciboPago[] = [];
   tipoFecha = 0;
   tipoDocumento = 0;
   tipoReciboPago = 2;
   public cantidad = 0;
   public userData: any = JSON.parse(sessionStorage.getItem('user'));
   public BILL_TAX_REGIME_ID: number;

   public listaCliente: Cliente[] = [];

   public reciboPago: ReciboPago = null;
   public listaReciboPagoDetalle: ReciboPagoDetalle[] = [];
   listaReciboPagoDocumento: ReciboPagoDocumento[] = [];

   public fechasForm = new FormControl(null, [Validators.required]);
   public clienteForm = new FormControl(null, [Validators.required]);
   public folioForm = new FormControl('', [Validators.maxLength(20)]);

   public btnSubmit = false;

   // Configuracion del daterangepicker
   locale: {
     format: 'DD/MM/YYYY',
     separator: ' - ',
     cancelLabel: 'Cancelar',
     applyLabel: 'Aceptar',
     firstDay: 1 // first day is monday
   };
   date = new Date();
   maxDate = moment().add(365, 'days');
   ranges: any = {
     'Hoy': [moment(), moment()],
     /* 'Semana actual': [moment().startOf('week'), moment().endOf('week')], */
     'Mes actual': [moment().startOf('month'), moment().endOf('month')],
     /* 'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment(), moment()], */
     'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()],
     /* 'Ultimos 3 meses': [moment().subtract(3, 'month').startOf('month'), moment(), moment()] */
   };
   dateRange: any = {
     startDate: moment().startOf('month'),
     endDate: moment()
   };

   public seleccionado: any;
   selectionMultiple = new SelectionModel<any>(true, []);

   public idDocuments: string = '';

   nombreCliente: string = null;
   rfcCliente: string = null;
   idSucursal: number = null;

   listaRegimenFiscal: FacturaRegimenFiscal[] = [];
   listaFormaPago: FacturaFormaPago[] = [];
   listaCFDI: FacturaUsoCFDI[] = [];
   listaSucursal: Organizacion[] = [];

   public PDF = null;
   public XML = null;
   public FILENAME_XML = '';
   public FILENAME_PDF = '';

   constructor(private _generalService: generalService, public dataService: DataService, public dialog: MatDialog, private sanitizer: DomSanitizer, public excelHeader: ExcelServiceHeader,
    public datePipe: DatePipe) {
     this.datosGeneralesSAE = DatosGeneralesSAE;
   }

   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(MatPaginator) paginator: MatPaginator;
   @ViewChild(MatPaginator) paginator2: MatPaginator;

   consultarRecibosPagos() {
     this.datosGeneralesSAE.showSpinnerLoading = true;
     if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {

       const reciboPago: any = {};

       reciboPago.loacs = sessionStorage.getItem('acslo');
       reciboPago.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
       reciboPago.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
       reciboPago.idCliente = this.clienteForm.value;
       reciboPago.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
       this._generalService.metodoCallParams(reciboPago, 'RecepcionPago/consultReceiptPayments').subscribe(
         (result) => {
           this.listaReciboPago = JSON.parse(result);
           this.dataSource = new DataSourceGrid(this.listaReciboPago, this.paginator, this.sort);
           console.warn(this.dataSource);
           this.cantidad = this.listaReciboPago.length;
           if (this.listaReciboPago.length <= 0) {
             $('.mat-row').remove('.mat-row');
             this._generalService.toastCall('No se encontraron registros');
           }
           this.datosGeneralesSAE.showSpinnerLoading = false;
         },
         (error) => {
           this.datosGeneralesSAE.showSpinnerLoading = false;
         }
         );
     } else {
       this.datosGeneralesSAE.showSpinnerLoading = false;
       this._generalService.toastCall('Las fechas son requeridas');
     }
   }

   consultarEstatusActual() {
     if (this.dateRange.startDate !== null && this.dateRange.endDate !== null /*&& this.clienteForm.value !== null*/) {

       const reciboPago: any = {};

       reciboPago.loacs = sessionStorage.getItem('acslo');
       reciboPago.fechaInicio = this.dateRange.startDate.format('YYYY-MM-DD 00:00:00');
       reciboPago.fechaFin = this.dateRange.endDate.format('YYYY-MM-DD 23:59:59');
       reciboPago.idCliente = this.clienteForm.value;
       reciboPago.folio = (this.folioForm.value === null) ? '' : this.folioForm.value;
       this._generalService.metodoCallParams(reciboPago, 'RecepcionPago/updateStatus').subscribe(
         (result) => {
           this._generalService.toastCall('Se actualizó el estatus a los recibos de pago exitosamente!');
           this.consultarRecibosPagos();
         },
         (error) => {

         }
         );
     } else {
       this._generalService.toastCall('Las fechas son requeridas');
     }
   }

   regresarReciboPago() {
    this.tipoDocumento = 0;
    this.tipoFecha = 0;
    this.dateRange = {
      startDate: moment().startOf('month'),
      endDate: moment()
    };
    this.tipoReciboPago = 2;
  }

   changeCliente() {
     if (this.clienteForm.value !== null) {
       const cliente = this.listaCliente.find((element) => element.idCliente === this.clienteForm.value);
       this.rfcCliente = cliente.rfc;
       this.nombreCliente = cliente.razonSocial;
     } else {
       this.rfcCliente = null;
       this.nombreCliente = null;
     }
   }

  editar(idReciboPago: number, CUSTOMER_ID: number) {
    this.dataService.id = idReciboPago;
    this.dataService.tipo = 'editar';
    this.idDocuments = null;
    this.dataService.factura = {
      idDocuments: this.idDocuments,
      tipoReciboPago: this.tipoReciboPago,
      idCliente: this.clienteForm.value ? this.clienteForm.value : CUSTOMER_ID,
      CUSTOMER_NAME: this.nombreCliente,
      CUSTOMER_RFC: this.rfcCliente
    };
    const dialogRef = this.dialog.open(ReciboPagoDetalleComponent, {disableClose: true, width: '95vw', height: '90vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se modificó exitosamente!');
        this.consultarRecibosPagos();
        this.regresarReciboPago();
      }
    });
  }

  agregar() {
    if (this.clienteForm.value !== null && this.clienteForm.value !== undefined) {
      this.dataService.id = null;
      this.dataService.tipo = 'agregar';
      this.idDocuments = '';
      if (this.selectionMultiple.selected.length > 0 ) {
        this.selectionMultiple.selected.forEach((element) => {
          this.idDocuments += element.DOCUMENT_ID + ',';
        });
        this.idDocuments = this.idDocuments.slice(0, -1);
      }

      //Se prepara para enviar el BILL_TAX_REGIME_ID al modal
      for(let i = 0; i < this.listaCliente.length; i ++){
        if(this.listaCliente[i].idCliente == this.clienteForm.value){
          this.BILL_TAX_REGIME_ID = this.listaCliente[i].BILL_TAX_REGIME_ID;
          break;
        }
      }

      this.dataService.factura = {
        idDocuments: this.idDocuments,
        tipoReciboPago: this.tipoReciboPago,
        idCliente: this.clienteForm.value,
        CUSTOMER_NAME: this.nombreCliente,
        CUSTOMER_RFC: this.rfcCliente,
        BILL_TAX_REGIME_ID: this.BILL_TAX_REGIME_ID
      };
    // this.dataService.idDocuments = this.idDocuments;
    // this.dataService.tipoReciboPago = this.tipoReciboPago;
      const dialogRef = this.dialog.open(ReciboPagoDetalleComponent, {
        disableClose: true, width: '95vw', height: '70vh', maxWidth: '95vw', maxHeight: '95vh', panelClass: 'full-width-dialog'
      });
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
        if (this.dataService.guardado) {
          this._generalService.toastCall('El registro se agregó exitosamente!');
          this.consultarRecibosPagos();
          this.regresarReciboPago();
        }
      });
    } else {
      this._generalService.toastCall('El cliente es requerido!');
      this.clienteForm.markAsTouched();
    }
  }

  consultarClientes() {
    const reciboPago: any = {};
    reciboPago.loacs = sessionStorage.getItem('acslo');

    this._generalService.metodoCallParams(reciboPago, 'cliente/consultarClientes').subscribe(
      (result) => {
        if ( JSON.parse(result) !== null &&  JSON.parse(result) !== undefined) {
          this.listaCliente = JSON.parse(result);
          this.viewDataCliente = this.listaCliente.slice(0, 10);
        } else {
          this.listaCliente = [];
        }
      },
      (error) => {

      }
      );
  }

  ngOnInit() {
    this.consultarClientes();
    this.consultarCFDI();
    this.consultarFormaPago();
    this.consultarRegimenFiscales();
    this.consultarSucursales();

    this.consultarRecibosPagos();
    /***************************INFINITE SELECT**********************************/    
     setTimeout(() => 
                this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
            2);
    /***************************INFINITE SELECT**********************************/
  }

  eliminarConfirm(data: any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.dataService.id = data.RECEIPT_PAYMENT_ID;

      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const idCompania = this.listaSucursal.find((row) => row.ORGANIZATION_ID === +idOrganizacion).COMPANY_ID;
      //this.dataService.factura = {idOrganizacion, idCompania, uuid: data.UUID, BILL_NUMBER: data.BILL_NUMBER};
      this.dataService.factura = {idOrganizacion, idCompania,
        uuid: data.UUID, 
        TOTAL: data.TOTAL, 
        MOTIVO: "02", 
         BILL_NUMBER: data.BILL_NUMBER
        };

      const dialogRef = this.dialog.open(ReciboPagoEliminarComponent, {disableClose: true});
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
          this.consultarRecibosPagos();
          this.btnSubmit = false;
        });
    } else {
      this.btnSubmit = false;
    }
  }

  public ExportarExcel() {
    const hoy = new Date();
    const fecha = hoy.getDate() + '/' + ( hoy.getMonth() + 1 ) + '/' + hoy.getFullYear();
    const hora = hoy.getHours() + ':' + hoy.getMinutes() + ':' + hoy.getSeconds();
    const fechayHora = fecha + ' ' + hora;

    const datosHeader = {
      cliente: this.nombreCliente,
      rfc: this.rfcCliente,
      segundoTextoHeader: 'MRSAE',
      tercerTextoHeader: 'Resumen de recibos de pago',
      fechaHoraImpresion: fechayHora,
      numeroPagina: 'Página 1 de 1'
    };

    if ( this.listaReciboPago.length > 0) {

      for(let i = 0; i < this.listaReciboPago.length ; i ++){
        this.listaReciboPago[i].FECHA_PAGO = this.datePipe.transform(this.listaReciboPago[i].PAYMENT_DATE, 'dd/MM/yyyy');
      }

      const filename = 'resumen-recibos-pagos' ;

      const columns = [{display: 'Cliente', name: 'CUSTOMER_NAME', tipoDato: 'string'},
      {display: 'Estatus', name: 'DESCRIPTION_STATUS', tipoDato: 'string'},
      {display: 'Numero De Folio', name: 'RECEIPT_PAYMENT_NUMBER', tipoDato: 'string'},
      {display: 'Total', name: 'TOTAL', tipoDato: 'moneda'},
      {display: 'Fecha de pago', name: 'FECHA_PAGO', tipoDato: 'string'},
      {display: 'Documentos Relacionados', name: 'DOCUMENTS', tipoDato: 'string'}
      ];

      this.excelHeader.exportXlsTableView( this.listaReciboPago, columns, filename, datosHeader);
    }
  }
  oneReciboSelect:any
  timbrarReciboPago(id: any,row:any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.reciboPago = new ReciboPago();
      this.reciboPago.RECEIPT_PAYMENT_ID = id;
      this.oneReciboSelect=row
      this.enviar(row.CUSTOMER_ID);
    }
  }

  download(id: any, idCompania: any) {
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.reciboPago = new ReciboPago();
      this.reciboPago.RECEIPT_PAYMENT_ID = id;
      this.recuperarArchivos(idCompania);
    }
  }

  enviar(idCliente: any) {
    console.warn(this.oneReciboSelect);
      const params = this.generarReciboPago(idCliente);
      var BILL_ID=this.oneReciboSelect.DOCUMENTS.split(",")[0];
      params.oneReciboSelect=this.oneReciboSelect;
      params.BILL_ID=BILL_ID;
      console.warn(params);
      
      this._generalService.requestPostParams(params, 'RecepcionPago/timbrar/').subscribe(
      (result) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const archivo = JSON.parse(result);
        this.PDF = archivo.PDF;
        this.XML = archivo.XML;
        this.FILENAME_XML = archivo.FILENAME_XML;
        this.FILENAME_PDF = archivo.FILENAME_PDF;

        const dialogRef = this.dialog.open(ReciboPagoDescargarComponent,  {disableClose: true}
          );

        dialogRef.afterClosed().subscribe((res) => {
          if (res) {
            // this.descargarArchivos();
            this.btnSubmit = false;
            this.download(params.reciboPagoModel.RECEIPT_PAYMENT_ID, idCliente)
          }
          this.btnSubmit = false;
          this.consultarRecibosPagos();
        });

      },
      (error) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
      
      }
    );
    
  }

  generarReciboPago(idCliente: any) {
    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const idOrganizacion = usuarioSession.ORGANIZATION_ID;
    const idCompania = usuarioSession.COMPANY_ID;
    const params: any = {};
    //const portEmailMessage : number = 4200;
    params.cliente = { idCliente: this.clienteForm.value ? this.clienteForm.value : idCliente};
    params.compania = { idCompania };

    const fechaActual = new Date();
    const mes = fechaActual.getMonth() + 1;
    const hora = (fechaActual.getHours() % 12) || 12;
    const minutos = fechaActual.getMinutes();
    const segundos = fechaActual.getSeconds();
    const fechaActualString = fechaActual.getFullYear() + '-' +
      ((mes > 9) ? mes : '0' + mes)  + '-' +
      ((fechaActual.getDate() > 9) ? fechaActual.getDate() : '0' + fechaActual.getDate() )  + 'T' +
      ((hora > 9) ? hora : '0' + hora)  + ':' +
      ((minutos > 9) ? minutos : '0' + minutos) + ':' +
      ((segundos > 9) ? segundos : '0' + segundos) ;
    params.Fecha = fechaActualString;

    params.reciboPagoModel = { ORGANIZATION_ID: idOrganizacion,
       loacs: sessionStorage.getItem('acslo'), 
       RECEIPT_PAYMENT_ID: this.reciboPago.RECEIPT_PAYMENT_ID };
    return params;
  }

  recuperarArchivos(idCliente: any) {
    const params = this.generarReciboPago(idCliente);
    this._generalService.requestPostParams(params, 'RecepcionPago/descargarArchivosReceiptPayment/').subscribe(
      (result) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const archivo = JSON.parse(result);
        this.PDF = archivo.PDF;
        this.XML = archivo.XML;
        this.FILENAME_XML = archivo.FILENAME_XML;
        this.FILENAME_PDF = archivo.FILENAME_PDF;
        this.descargarArchivos();
        this.consultarRecibosPagos();
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
        this.btnSubmit = false;
      }
      );
  }

  descargarArchivos() {
    const blob = this.base64PDFToBlob(this.PDF);

    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.FILENAME_PDF + '.pdf';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();

    const bb = new Blob([this.XML], {type: 'text/plain'});

    link = document.createElement('a');
    link.href = URL.createObjectURL(bb);
    link.download = this.FILENAME_XML + '.xml';
    // some browser needs the anchor to be in the doc
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  crearPDF() {
    const params = {};
    this._generalService.requestPostParams(params, 'RecepcionPago/crearPDF/').subscribe(
      (result) => {
        const archivo = result;
        const blob = this.base64PDFToBlob(archivo);
        window.open(URL.createObjectURL(blob));
      },
      (error) => {

      }
      );
  }

  base64PDFToBlob(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: 'application/pdf' });
  }

  consultarSucursales() {
    this._generalService.metodoCall(`compania/consultarSucursales/`).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0) {
          this.listaSucursal = res;
        } else {
          this.listaSucursal = [];
        }
      },
      (error) => {
        this.listaSucursal = [];
        
      }
      );
  }

  consultarRegimenFiscales() {
    this._generalService.metodoCall(`factura/getRegimenFiscal/`).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0) {
          this.listaRegimenFiscal = res;
        } else {
          this.listaRegimenFiscal = [];
        }
      },
      (error) => {
        this.listaRegimenFiscal = [];

      }
      );
  }

  consultarFormaPago() {
    this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0) {
          this.listaFormaPago = res;
        } else {
          this.listaFormaPago = [];
        }
      },
      (error) => {
        this.listaFormaPago = [];

      }
      );
  }

  consultarCFDI() {
    this._generalService.metodoCall(`factura/getCFDI/`).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0) {
          this.listaCFDI = res;
        } else {
          this.listaCFDI = [];
        }
      },
      (error) => {
        this.listaCFDI = [];

      }
      );
  }

  fetchMore() {
    if(this.itemsShow < this.listaCliente.length) {
      this.itemsShow += 10;
      this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
    }  
  }

  preparPDFYXMLEnvioPorCorreo(id: any, row: any){
    
    if (!this.btnSubmit) {
      this.btnSubmit = true;
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.reciboPago = new ReciboPago();
      this.reciboPago.RECEIPT_PAYMENT_ID = id;
      this.oneReciboSelect=row
      this.recuperarArchivosCorreo(row)
    }
  }

  recuperarArchivosCorreo(idCliente: any){
    const params = this.generarReciboPago(idCliente);
    this._generalService.requestPostParams(params, 'RecepcionPago/descargarArchivosReceiptPayment/').subscribe(
      (result) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const archivo = JSON.parse(result);
        this.PDF = archivo.PDF;
        this.XML = archivo.XML;
        this.FILENAME_XML = archivo.FILENAME_XML;
        this.FILENAME_PDF = archivo.FILENAME_PDF;
        this.enviarPDFYXMLPorCorreo(idCliente);
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
        this.btnSubmit = false;
      }
      );
  }

   enviarPDFYXMLPorCorreo(idCliente: any)
  {
     const params = this.generarReciboPago(idCliente);
    this._generalService.requestPostParams(params, 'RecepcionPago/enviarArchivosDeReceiptPaymentPorEmail/').subscribe(
      (result) => {
        this.btnSubmit = false;
        this.datosGeneralesSAE.showSpinnerLoading = false;
        const response = result;
        if(response == "ok")
        {
          this._generalService.toastCall("Envio por E-Mail Correctamente");
        }
        else
        {
          this._generalService.toastCall(response);
        }
        
      },
      (error) => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
        this._generalService.handleError(error);
        this.btnSubmit = false;
      }
    );
  }


  onKeyUpCliente(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredCliente = this.listaCliente.filter((obj) => {
        return obj.razonSocial.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
      this.isFilteredCliente = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredCliente = false;
      this.filteredItemsShowCliente = 10;
      this.arrayFilteredCliente = undefined;
      arr = this.listaCliente.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    this.viewDataCliente = arr;
    /***************************INFINITE SELECT**********************************/
  }

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredCliente) {
        if(this.filteredItemsShowCliente < this.arrayFilteredCliente.length) {
            this.filteredItemsShowCliente += 10;
            this.viewDataCliente = this.arrayFilteredCliente.slice(0, this.filteredItemsShowCliente);
        }
      } else {
        if(this.itemsShow < this.listaCliente.length) {
          this.itemsShow += 10;
          this.viewDataCliente = this.listaCliente.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/

}



// WEBPACK FOOTER //
// ./src/app/recibo-pago/consultar-eliminar/recibo-pago-consultar.component.ts